import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SurveyQuestion } from '../models/SurveyQuestion';
import { SurveyAnswer } from '../models/SurveyAnswer';

@Injectable({
    providedIn: 'root',
})
export class SurveyService {
    constructor(private http: HttpClient) {}

    getSurveyQuestions(): Observable<SurveyQuestion[]> {
        const url = `/api/v1/survey/questions`;

        return this.http.get<SurveyQuestion[]>(url);
    }

    postSurveyAnswers(answers: SurveyAnswer[]): Observable<any> {
        const url = `/api/v1/survey/answers`;
        const body = answers;

        return this.http.post<any>(url, body);
    }
}
